import { useEffect } from 'react';

import { useGlobalAlerts } from '@fsd/entities/global-alert';
import { topNotificationStore } from '../store/NotificationStore';

import { MissingPurchasePriceAlert } from '../../ui/alerts/MissingPurchasePriceAlert'
import { MissingCounterpartyBalanceAlert } from '../../ui/alerts/MissingCounterpartyBalanceAlert';
import { GlobalAlertsContent } from '../../ui/GlobalAlertsContent/GlobalAlertsContent';

export const useGlobalAlertsNotifications = () => {
  const { data } = useGlobalAlerts();

  useEffect(() => {
    if (!data) return;

    const activeAlerts = data.errors.filter((alert) => alert.has_error);

    topNotificationStore.setGlobalAlertsCount(activeAlerts.length);

    if (!activeAlerts.length) {
      topNotificationStore.syncGlobalAlerts([]);
      return;
    }

    const messages = activeAlerts.map((alert) => {
      switch (alert.type) {
        case 'missing_purchase_price':
          return (
            <MissingPurchasePriceAlert
              key={alert.type}
              alert={alert}
            />
          );

        case 'missing_counterparty_initial_balance':
          return (
            <MissingCounterpartyBalanceAlert
              key={alert.type}
              alert={alert}
            />
          );

        default:
          return null;
      }
    });

    topNotificationStore.syncGlobalAlerts([
      {
        key: 'validation-summary',
        type: 'error',
        message: <GlobalAlertsContent messages={messages} />,
      },
    ]);
  }, [data]);
};